import React from "react";

import { Box, Drawer, useTheme, IconButton, styled } from "@mui/material";
import { ResourceDrawerList } from "./List";
import { DrawerUserInformation } from "./UserInformation";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  padding: theme.spacing(0, 1),
  ...theme.mixins.toolbar,
  justifyContent: "space-between",
  position: "sticky",
  top: 0,
  zIndex: 1,
  borderBottom: `1px solid ${theme.palette.divider}`,
  backgroundColor: theme.palette.primary.dark
}));

export const ResourceDrawer = ({ email, isOpen, toggleIsOpen }) => {
  const theme = useTheme();

  const content = (
    <Box
      position="relative"
      display="flex"
      flexDirection="column"
      height="100%"
    >
      <DrawerHeader>
        <svg
          width="75%"
          height="24"
          viewBox="0 0 335 46"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M320.052 46C328.949 46 335 41.0621 335 32.1935C335 25.2848 329.64 20.6069 322.888 18.6361C316.773 16.8602 314.691 15.9722 314.691 12.8103C314.691 10.2764 316.708 8.56544 319.491 8.56544C322.273 8.56544 324.538 10.5904 324.668 14.3263H334.439C333.868 5.27354 328.443 0.0758004 319.491 0.0758004C310.539 0.0758004 304.737 5.5226 304.737 13.5033C304.737 21.484 309.967 25.0899 316.536 26.8658C322.974 28.5118 324.991 29.7787 324.991 33.1356C324.991 35.5395 323.223 37.4995 320.138 37.4995C317.053 37.4995 314.648 35.4746 314.271 31.3597H304.37C304.995 40.6723 310.798 45.9892 320.073 45.9892M289.012 0.844633V29.8545L279.046 6.22646C277.407 2.3065 274.7 0.400659 271.162 0.400659C267.441 0.400659 264.281 2.93456 264.281 7.68832V45.242H273.427V14.5862L284.083 39.4703C286.035 44.0942 288.44 45.6751 291.773 45.6751C295.105 45.6751 298.147 43.6502 298.147 39.1563V0.844633H289.001H289.012ZM235.15 36.5683C227.644 36.5683 222.284 30.6125 222.284 23.0108C222.284 15.4091 227.644 9.51836 235.15 9.51836C242.657 9.51836 248.017 15.4741 248.017 23.0108C248.017 30.5476 242.657 36.5683 235.15 36.5683ZM235.15 46C248.211 46 258.673 35.6803 258.673 23.0108C258.673 10.3413 248.136 0.086629 235.15 0.086629C222.165 0.086629 211.682 10.4063 211.682 23.0108C211.682 35.6153 222.025 46 235.15 46ZM197.682 0.400659C193.207 0.400659 190.047 3.31356 188.666 8.76036L181.666 36.3084L174.473 8.76036C173.017 3.12947 170.115 0.400659 165.704 0.400659C161.293 0.400659 157.313 3.69256 157.313 9.45339V45.242H166.459V10.2222L173.772 38.2792C175.033 43.0979 177.493 45.686 181.72 45.686C185.948 45.686 188.407 43.0221 189.604 38.2792L196.917 9.77825V45.242H206.063V9.45339C206.063 3.69256 202.342 0.400659 197.672 0.400659M140.844 0.400659C136.304 0.400659 133.273 3.31356 131.893 8.76036L124.828 36.3084L117.634 8.76036C116.125 3.0645 113.288 0.400659 108.866 0.400659C104.444 0.400659 100.475 3.69256 100.475 9.45339V45.242H109.621V10.2222L116.933 38.2792C118.195 43.0979 120.654 45.686 124.882 45.686C129.11 45.686 131.504 43.0221 132.701 38.2792L140.079 9.77825V45.242H149.224V9.45339C149.224 3.69256 145.439 0.400659 140.834 0.400659M71.9591 36.5574C64.4525 36.5574 59.0276 30.6017 59.0276 23C59.0276 15.3983 64.4525 9.50753 71.9591 9.50753C79.4656 9.50753 84.8258 15.4633 84.8258 23C84.8258 30.5367 79.4656 36.5574 71.9591 36.5574ZM71.9591 45.9892C85.02 45.9892 95.4169 35.6695 95.4169 23C95.4169 10.3305 84.966 0.086629 71.9698 0.086629C58.9736 0.086629 48.4472 10.4063 48.4472 23.0108C48.4472 35.6153 58.9197 46 71.9698 46M23.3392 46C40.9947 46 44.5969 30.6125 44.5969 29.5297H34.6314C32.6145 33.9044 28.6995 36.4925 23.4039 36.4925C16.1563 36.4925 10.5372 31.1756 10.6019 23C10.6666 14.8244 16.1563 9.50753 23.4039 9.50753C28.6995 9.50753 32.6145 12.1064 34.6314 16.4703H44.5969C44.5969 15.3983 41.0054 0 23.3392 0C10.4725 0.0216572 0 9.77825 0 23.0108C0 36.2434 10.4725 46 23.3392 46Z"
            fill="currentColor"
          />
        </svg>

        <IconButton onClick={toggleIsOpen}>
          <ChevronLeftIcon />
        </IconButton>
      </DrawerHeader>
      <Box flexGrow={1}>
        <ResourceDrawerList />
      </Box>
      <Box position="sticky" bottom="0" width="100%">
        <DrawerUserInformation email={email} />
      </Box>
    </Box>
  );

  return (
    <Drawer
      variant="persistent"
      anchor="left"
      open={isOpen}
      sx={{
        width: isOpen ? "255px" : 0,
        flexShrink: 0,
        "& .MuiDrawer-paper": {
          width: isOpen ? "255px" : 0,
          boxSizing: "border-box",
          backgroundColor: theme.palette.primary.dark
        }
      }}
    >
      {content}
    </Drawer>
  );
};
